import { memo } from 'react';

import { LinkIcon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';
import { Tooltip } from '@air/primitive-tooltip';

export type ShareButtonProps = Pick<Required<ButtonProps>, 'onClick'> &
  Pick<ButtonProps, 'color'> & {
    label?: string;
  };

export const ShareButton = memo(({ onClick, color = 'blue', label = 'Share' }: ShareButtonProps) => (
  <Tooltip label={label}>
    <Button
      prefix={<LinkIcon size="xs" />}
      appearance="filled"
      color={color}
      data-testid="SELECTION_ACTION_BAR_SHARE"
      onClick={onClick}
      size="small"
    >
      {label}
    </Button>
  </Tooltip>
));

ShareButton.displayName = 'ShareButton';
